module.exports = __webpack_public_path__ + "static/media/mobile.558b8aea.svg";